import PropTypes from 'prop-types';
import DataGridContextProvider from '@common/components/DataGrid/DataGridContextProvider';

export default function DataGridBody({ children }) {
  return (
    <DataGridContextProvider type="body">
      <tbody>{children}</tbody>
    </DataGridContextProvider>
  );
}

DataGridBody.propTypes = {
  children: PropTypes.node,
};
